<script setup lang="ts">
const { $fcm } = useNuxtApp();
const items = ref([
  {
    label: "",
  },
]);
const menus = ref([
  {
    label: "Notifications",
  },
  {
    label: "Events",
  },
]);

const messages = ref([]);
$fcm.store.$subscribe((mutation, state) => {
  messages.value = $fcm.store.messagesValue;
});
</script>

<template lang="pug">
    .flex.relative
        UDropdownMenu(
            :items="items"
            :ui="{content: 'w-60 bg-white'}"
        )
            UChip(
                inset
                :show="messages.length > 0"
            )
                UButton(
                    class="cursor-pointer"
                    icon="si:notifications-thick-line"
                    color="neutral"
                    variant="ghost"
                )
            //- UButton(
            //-     v-else
            //-     class="cursor-pointer"
            //-     icon="si:notifications-thick-line"
            //-     color="neutral"
            //-     variant="ghost"
            //- )
            template(#item)
                //- UTabs(
                //-     size="xs"
                //-     color="neutral"
                //-     variant="link"
                //-     :items="menus"
                //-     class="-mt-2 w-full"
                //- )
                //-     template(#content="{ item }")
                .flex.flex-1.relative.flex-col
                    .w-full(
                        v-if="messages.length <= 0"
                    ) Tidak ada notifikasi untuk saat ini

                    .w-full.space-y-2(v-else)
                        .w-full.space-y-2.font-normal(v-for="(c,index) in messages" :key="c.messageId")
                            NuxtLink.w-full.flex.flex-col.flex-1(
                                variant="ghost"
                                color="neutral"
                                :to="c?.fcmOptions?.link"
                            )
                                .flex.flex-1.flex-col.justify-start
                                    .flex.flex-1.justify-start.text-xs.font-medium {{ c?.notification?.title }}
                                    .flex.flex-1.justify-start.text-xs.text-left {{ c?.notification?.body }}
                            USeparator(v-if="index !== messages.length - 1")
</template>
